import _ from 'lodash';

export class ChatId {
   public constructor(public callId: number, public messageId: string, public uid?: string) {
      // nothing to do
   }

   public equals(other: ChatId): boolean {
      if (_.isNil(other)) return false;
      if (_.isEmpty(other.uid) || _.isEmpty(this.uid)) return this.callId === other.callId && this.messageId === other.messageId;
      return this.uid === other.uid;
   }
}
